import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject
} from '@angular/core';
import { ProgramBannerFacade } from '~backoffice/app/~store/facades/program-banner.facade';
import { Program } from '~core/models/program.models';

@Component({
  standalone: false,
  selector: 'program-banner-editor',
  templateUrl: './program-banner-editor.component.html',
  styleUrls: ['./program-banner-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProgramBannerFacade]
})
export class ProgramBannerEditorComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input() program: Program | null | undefined;
  programBannerFacade = inject(ProgramBannerFacade);
  banners$ = this.programBannerFacade.banners$;
  bannerLoadError$ = this.programBannerFacade.bannerLoadError$;
  canSaveSelectedBanner$ = this.programBannerFacade.canSaveSelectedBanner$;
  canUserInteract$ = this.programBannerFacade.canUserInteract$;
  isSavingBanner$ = this.programBannerFacade.isSavingBanner$;
  isLoadingBanner$ = this.programBannerFacade.isLoadingBanner$;

  ngOnInit(): void {
    this.programBannerFacade.resetState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('program' in changes) {
      this.loadBanners();
    }
  }

  ngAfterViewInit(): void {
    this.loadBanners();
  }

  loadBanners(): void {
    setTimeout(() => {
      if (!this.program) return;
      this.programBannerFacade.loadBanners({
        programId: this.program.id,
        banners: this.program.banner ? [this.program.banner] : []
      });
    }, 250);
  }

  saveBanner(): void {
    this.programBannerFacade.saveBanner();
  }

  get title(): string {
    return `Bannières ${this.program?.name || ''}`;
  }
}
